import { service } from '../../../helpers/http'

export const ActionAlgorithmRunsIndex = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'indexRuns',
    payload,
  })
}

export const ActionAlgorithmRunsShow = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'showRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsDelete = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'deleteRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsEvents = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'eventsRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTimetableRun',
    payload,
  })
}

export const ActionAlgorithmRunsTimetableGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTimetableRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createBasicEducationRun',
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilot = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotDiagnostics = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotDiagnosticsTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotPending = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotPendingTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotEntities = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotEntitiesTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotTeacherAvailability = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotTeacherAvailabilityTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotCompare = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotCompareTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTimetableCopilotSuggestions = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotSuggestionsTimetableRun',
    idAndPayload: true,
    payload,
  })
}

// POST: parâmetros de rota em `params`, corpo em `payload` (vue-resource save).
export const ActionAlgorithmRunsTimetableCopilotMeasure = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotMeasureTimetableSuggestion',
    params: { id: payload.id, suggestionId: payload.suggestion_id },
    payload: { deep: !!payload.deep },
  })
}

export const ActionAlgorithmRunsTimetableCopilotMeasureAll = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotMeasureAllTimetableSuggestions',
    params: { id: payload.id },
    payload: {},
  })
}

export const ActionAlgorithmRunsTimetableCopilotSimulate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotSimulateTimetableRun',
    params: { id: payload.id },
    payload: { suggestion_ids: payload.suggestion_ids, full: !!payload.full },
  })
}

export const ActionAlgorithmRunsTimetableCopilotApplyScenario = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotApplyScenarioTimetableRun',
    params: { id: payload.id },
    payload: { scenario_run_id: payload.scenario_run_id },
  })
}

// `groupId` é parâmetro de rota: com `idAndPayload` o vue-resource preenche
// a URL a partir do próprio payload.
export const ActionAlgorithmRunsTimetableCopilotGroupSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotGroupSummaryTimetableRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationCopilot = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'copilotBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationDiagnostics = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'diagnosticsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'groupsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

// Disponibilidade do professor como o solver a viu no run (aba Grade).
export const ActionAlgorithmRunsBasicEducationTeacherAvailability = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'teacherAvailabilityBasicEducationRun',
    params: { id: payload.id, teacherId: payload.teacher_id },
  })
}

export const ActionAlgorithmRunsBasicEducationResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsBasicEducationSuggestions = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'suggestionsBasicEducationRun',
    idAndPayload: true,
    payload,
  })
}

// POST com id na rota: `params` resolve o {id} e `payload` vai no CORPO.
// Com `idAndPayload` o helper chama a action com UM argumento só, que o Vue
// Resource trata como query string — o corpo iria vazio e a validação falharia.
export const ActionAlgorithmRunsBasicEducationSimulate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'simulateBasicEducationRun',
    params: { id: payload.id },
    // `full`: reotimizar a escola inteira em vez do cenário local.
    payload: { suggestion_ids: payload.suggestion_ids, full: !!payload.full },
  })
}

// Medir o impacto de UMA sugestão. `deep` = medir a fundo (probe global).
export const ActionAlgorithmRunsBasicEducationMeasure = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'measureBasicEducationSuggestion',
    params: { id: payload.id, suggestionId: payload.suggestion_id },
    payload: { deep: !!payload.deep },
  })
}

// Medição automática em lote (probes locais de tudo que ainda não foi medido).
export const ActionAlgorithmRunsBasicEducationMeasureAll = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'measureAllBasicEducationSuggestions',
    params: { id: payload.id },
    payload: {},
  })
}

export const ActionAlgorithmRunsBasicEducationApplyScenario = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyScenarioBasicEducationRun',
    params: { id: payload.id },
    payload: { scenario_run_id: payload.scenario_run_id },
  })
}

export const ActionAlgorithmRunsTeacherAttributionCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createTeacherAttributionRun',
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionApply = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyTeacherAttributionRun',
    params: { id: payload.id },
    payload: payload.grid_ids ? { grid_ids: payload.grid_ids } : {},
  })
}

export const ActionAlgorithmRunsTeacherAttributionSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listTeacherAttributionRunGroups',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionItems = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'itemsTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsTeacherAttributionTeachersBoard = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'teachersBoardTeacherAttributionRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationCreate = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createAmbienceAllocationRun',
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationResults = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resultsAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationUnassigned = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'unassignedAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationSummary = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'summaryAmbienceAllocationRun',
    idAndPayload: true,
    payload,
  })
}

export const ActionAlgorithmRunsAmbienceAllocationGroups = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listAmbienceAllocationRunGroups',
    idAndPayload: true,
    payload,
  })
}

/** payload: { id: runId, segment } */
export const ActionAlgorithmRunsAmbienceCopilot = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilot',
    idAndPayload: true,
    payload,
  })
}

/** payload: { id: runId, segment } */
export const ActionAlgorithmRunsAmbienceCopilotDiagnostics = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotDiagnostics',
    idAndPayload: true,
    payload,
  })
}

/** payload: { id: runId } */
export const ActionAlgorithmRunsAmbienceCopilotEntities = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotEntities',
    idAndPayload: true,
    payload,
  })
}

/** payload: { runId, view: 'ambience'|'group'|'block', id, day } — id/view/day viram query. */
export const ActionAlgorithmRunsAmbienceCopilotMap = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotMap',
    idAndPayload: true,
    payload,
  })
}

/** payload: { id: runId } → { suggestions, probing_count, measure_limit, last_scenario } */
export const ActionAlgorithmRunsAmbienceCopilotSuggestions = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotSuggestions',
    idAndPayload: true,
    payload,
  })
}

// POSTs: parâmetros de rota em `params`, corpo em `payload` (vue-resource save).
/** payload: { id: runId, suggestion_id } → { probe_run_id, status } */
export const ActionAlgorithmRunsAmbienceCopilotMeasure = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotMeasure',
    params: { id: payload.id, suggestionId: payload.suggestion_id },
    payload: {},
  })
}

/** payload: { id: runId } → { enqueued } */
export const ActionAlgorithmRunsAmbienceCopilotMeasureAll = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotMeasureAll',
    params: { id: payload.id },
    payload: {},
  })
}

/** payload: { id: runId, suggestion_ids: number[] } → { scenario_run_id, status } */
export const ActionAlgorithmRunsAmbienceCopilotSimulate = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotSimulate',
    params: { id: payload.id },
    payload: { suggestion_ids: payload.suggestion_ids },
  })
}

/** payload: { id: runId, scenario_run_id } */
export const ActionAlgorithmRunsAmbienceCopilotApplyScenario = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'ambienceCopilotApplyScenario',
    params: { id: payload.id },
    payload: { scenario_run_id: payload.scenario_run_id },
  })
}

export const ActionAlgorithmRunsAmbienceBalanceCreate =({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'createAmbienceBalanceRun',
    payload,
  })
}

// Copiloto de Balanceamento de Ambientes ----------------------------------

/** payload: { id: runId, segment } */
export const ActionAlgorithmRunsBalanceCopilot = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilot', idAndPayload: true, payload })
}

/** payload: { id: runId, segment, severity? } */
export const ActionAlgorithmRunsBalanceCopilotDiagnostics = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotDiagnostics', idAndPayload: true, payload })
}

/** payload: { id: runId, segment, diagnostic_id?, severity?, page, per_page } */
export const ActionAlgorithmRunsBalanceCopilotPending = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotPending', idAndPayload: true, payload })
}

/** payload: { id: runId } */
export const ActionAlgorithmRunsBalanceCopilotEntities = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotEntities', idAndPayload: true, payload })
}

/** payload: { runId, level, id?, shift_id?, nature, required_type_id?, final_type_id? } */
export const ActionAlgorithmRunsBalanceCopilotSlice = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotSlice', idAndPayload: true, payload })
}

/** payload: { runId, level, id?, shift_id?, page, per_page } */
export const ActionAlgorithmRunsBalanceCopilotSwaps = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotSwaps', idAndPayload: true, payload })
}

/** payload: { id: runId, campus_id?, block_id?, search?, sort?, page, per_page } */
export const ActionAlgorithmRunsBalanceCopilotAmbiences = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotAmbiences', idAndPayload: true, payload })
}

/** payload: { id: runId, ambienceId } — rota com {ambienceId}: params explícito. */
export const ActionAlgorithmRunsBalanceCopilotAgenda = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'balanceCopilotAgenda',
    params: { id: payload.id, ambienceId: payload.ambienceId },
  })
}

/** payload: { id: runId } */
export const ActionAlgorithmRunsBalanceCopilotSuggestions = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotSuggestions', idAndPayload: true, payload })
}

/** payload: { id: runId, suggestion_id } */
export const ActionAlgorithmRunsBalanceCopilotMeasure = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'balanceCopilotMeasure',
    params: { id: payload.id, suggestionId: payload.suggestion_id },
    payload: {},
  })
}

/** payload: { id: runId } */
export const ActionAlgorithmRunsBalanceCopilotMeasureAll = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotMeasureAll', params: { id: payload.id }, payload: {} })
}

/** payload: { id: runId, suggestion_ids } */
export const ActionAlgorithmRunsBalanceCopilotSimulate = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'balanceCopilotSimulate',
    params: { id: payload.id },
    payload: { suggestion_ids: payload.suggestion_ids },
  })
}

/** payload: { id: runId, scenario_run_id } */
export const ActionAlgorithmRunsBalanceCopilotApplyScenario = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'balanceCopilotApplyScenario',
    params: { id: payload.id },
    payload: { scenario_run_id: payload.scenario_run_id },
  })
}

/** payload: { id: runId, scenarioRunId, page, per_page } — rota com {scenarioRunId}. */
export const ActionAlgorithmRunsBalanceCopilotScenarioChanges = (context, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'balanceCopilotScenarioChanges',
    params: { id: payload.id, scenarioRunId: payload.scenarioRunId, page: payload.page, per_page: payload.per_page },
  })
}

/** payload: { id: runId } */
export const ActionAlgorithmRunsBalanceCopilotCompare = (context, payload) => {
  return service({ module: 'algorithmRuns', action: 'balanceCopilotCompare', idAndPayload: true, payload })
}


// Painéis escolhidos pelo usuário na tela de resultado (um layout por algoritmo).
export const ActionAlgorithmResultLayoutShow = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'showResultLayout',
    params: { algorithmKey: payload.algorithmKey },
  })
}

export const ActionAlgorithmResultLayoutSave = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'saveResultLayout',
    params: { algorithmKey: payload.algorithmKey },
    payload: { mode: payload.mode, panels: payload.panels },
  })
}

export const ActionAlgorithmResultLayoutReset = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'resetResultLayout',
    params: { algorithmKey: payload.algorithmKey },
  })
}
